<div class="preferencePage">
  <div class="header">
    <div class="d-flex mb-3">
      <h3>{{ preferenceMessages.title | translate }}</h3>
    </div>
  </div>
  <div class="tab-block">
    <div class="row">
      <div class="col-lg-12 col-md-10 tab-block">
        <ul class="nav nav-pills" role="tablist" aria-label="liste onglet preference">
          <!-- Masqué suite au masquage SHAL/JAL -->
          <!-- <li class="nav-item" role="presentation" *ngIf="isComptesAnnonceur">
            <a (click)="activeTab(1)" aria-controls="pills-one" aria-selected="true" class="nav-link active"
              data-toggle="pill" id="pills-one-tab" role="tab">{{ preferenceMessages.tab_1_label_1 | translate }}</a>
          </li> -->
          <!-- Masqué suite au masquage liste CPV -->
          <!-- <li class="nav-item" role="presentation" *ngIf="isComptesAnnonceur">
            <a (click)="activeTab(2)" aria-controls="pills-two" aria-selected="false" class="nav-link active"
              data-toggle="pill" id="pills-two-tab" role="tab">{{ preferenceMessages.tab_2_label_1 | translate }}</a>
          </li> -->
          <!-- Masqué suite au masquage SHAL/JAL -->
          <!-- <li class="nav-item" role="presentation" *ngIf="isComptesAnnonceur">
            <a (click)="activeTab(3)" aria-controls="pills-three" aria-selected="false" class="nav-link"
              data-toggle="pill" id="pills-three-tab" role="tab">{{ preferenceMessages.tab_3_label_1 | translate }}</a>
          </li> -->
          <li class="nav-item" role="presentation" *ngIf="isComptesFacturation">
            <a (click)="activeTab(4)" aria-controls="pills-four" aria-selected="false" class="nav-link"
              data-toggle="pill" id="pills-four-tab" role="tab">{{ preferenceMessages.tab_4_label_1 | translate }}</a>
          </li>
          <li class="nav-item" role="presentation" *ngIf="isComptesAnnonceur">
            <a (click)="activeTab(5)" aria-controls="pills-five" aria-selected="false" class="nav-link"
              data-toggle="pill" id="pills-five-tab" role="tab">{{ preferenceMessages.tab_5_label_1 | translate }}</a>
          </li>
          <li class="nav-item" role="presentation" *ngIf="isComptesAnnonceur">
            <a (click)="activeTab(6)" aria-controls="pills-six" aria-selected="false" class="nav-link"
              data-toggle="pill" id="pills-six-tab" role="tab">{{ preferenceMessages.tab_6_label_1 | translate }}</a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <!-- Masqué suite au masquage SHAL/JAL -->
          <!-- <div [hidden]="!(isNewActive!==2 && isNewActive!==3 && isNewActive!==4 && isNewActive!==5 && isNewActive!==6)" aria-labelledby="pills-one-tab"
            class="content fade show active" id="pills-one" role="tabpanel">
            <app-preferences-liste-diffusion></app-preferences-liste-diffusion>
          </div> -->
          <!-- Masqué suite au masquage liste CPV -->
          <!-- <div *ngIf="isNewActive!==1 && isNewActive!==3 && isNewActive!==4 && isNewActive!==5 && isNewActive!==6" aria-labelledby="pills-two-tab"
            class="content fade show active" id="pills-two" role="tabpanel">
            <app-preferences-liste-cpv></app-preferences-liste-cpv>
          </div> -->
          <!-- Masqué suite au masquage SHAL/JAL -->
          <!-- <div *ngIf="isNewActive!==2 && isNewActive!==1 && isNewActive!==4 && isNewActive!==5 && isNewActive!==6" aria-labelledby="pills-three-tab"
            class="content fade show active" id="pills-three" role="tabpanel">
            <app-preferences-logo></app-preferences-logo>
          </div> -->
          <div *ngIf="isNewActive!==2 && isNewActive!==3 && isNewActive!==1 && isNewActive!==5 && isNewActive!==6" aria-labelledby="pills-four-tab"
            class="content fade show active" id="pills-four" role="tabpanel">
            <app-preferences-liste-facturation></app-preferences-liste-facturation>
          </div>
          <div *ngIf="isNewActive!==2 && isNewActive!==3 && isNewActive!==1 && isNewActive!==4 && isNewActive!==6" aria-labelledby="pills-five-tab"
            class="content fade show active" id="pills-five" role="tabpanel">
            <app-preferences-compte-annonceur></app-preferences-compte-annonceur>
          </div>
          <div *ngIf="isNewActive!==2 && isNewActive!==3 && isNewActive!==1 && isNewActive!==4 && isNewActive!==5" aria-labelledby="pills-six-tab"
            class="content fade show active" id="pills-six" role="tabpanel">
            <app-preferences-acheteur-principal></app-preferences-acheteur-principal>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
